import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { ResultData } from '@/services/Sierra';
import { getTotalTraceCapacitance, reCalcCapacitanceByFreq, getTotalTraceCapacitanceTableData } from '../../../../services/Sierra/results';
import TotalCapacitance from '../components/totalCapacitance';
import { DIODE, JUMPER, RLC_TYPES } from '../../../../services/PCBHelper';
import { CapacitancePlot } from '../../../../services/Sierra/results/totalTraceCapacitance/capacitancePlot';
import designConstructor from '../../../../services/helper/designConstructor';
import { PRE_LAYOUT } from '../../../../constants/designVendor';
import resultOperation from '../../../../services/Result/Public/resultOperation';
import { CAPACITANCE } from '../../../../services/Result/Public/resultConstants';
import "../index.css";
import { SCHEMATIC } from '../../../../services/Sierra/prelayout/prelayoutConstants';

class TotalTraceCapacitance extends PureComponent {
  constructor(props) {
    super(props);
    const { verificationId } = props;
    const resultOpera = resultOperation.getOperationByKey(verificationId, CAPACITANCE) || {};
    this.state = {
      designs: [],
      frequency: "",
      freqUnit: "M",
      loading: false,
      pathObj: {},
      isUpdateData: false,
      minFreq: 1e3,
      resultOpera,
      displayMode: "curve",
      hideFreq: false
    }
    this.capacitancePlot = new CapacitancePlot();
  }

  componentDidMount = () => {
    const { verificationSubId, verificationId } = this.props;
    if (verificationId && verificationSubId) {
      this.getData()
    }
  }

  componentDidUpdate = (prevProps) => {
    const { verificationSubId, verificationId } = this.props;
    if (verificationId !== prevProps.verificationId && verificationSubId) {
      this.getData()
    }
  }

  getData = async () => {
    const { verificationSubId, currentProjectId, verificationId } = this.props;
    let designs = [], _logSweepMin = 1e3;
    this.capacitancePlot = new CapacitancePlot();
    let preLayoutInfoList = []
    try {
      preLayoutInfoList = await ResultData.getPreLayoutJsonByVerificationId(verificationId);
    } catch (error) {
      console.error(error);
    }
    try {
      const res = await ResultData.getVerificationJsonPromise(verificationSubId, verificationId, currentProjectId);
      if (res) {
        let currentInterfaces = ResultData.getInterfaces() || [];
        designs = currentInterfaces.map(item => {
          let isTemplateSchematic = false;
          const isPreLayout = designConstructor.getDesignVendor(item.PCBID) === PRE_LAYOUT;
          if (isPreLayout) {

            const findInfo = preLayoutInfoList.find(it => it.subId === item.pcbId || it.id === item.PCBID || it.designId === item.pcbId);
            isTemplateSchematic = findInfo && findInfo.content && findInfo.content.prelayout === SCHEMATIC && (!findInfo.content.mode || findInfo.content.mode === "Template");
            if (!isTemplateSchematic) {
              return null
            }
          }
          const components = item.content && item.content.components ? item.content.components.filter(it => ![...RLC_TYPES, DIODE, JUMPER].includes(it.type)).map(it => it.name) : []
          const itemLogSweepMin = item.content && item.content.extraction && !isNaN(item.content.extraction.logSweepMin) ? item.content.extraction.logSweepMin : 1e9
          if (itemLogSweepMin < _logSweepMin) {
            _logSweepMin = itemLogSweepMin
          };
          return {
            id: item.pcbId,
            name: item.pcb,
            components,
            isTemplateSchematic
          };
        }).filter(item => !!item)
      }
      if (designs.length > 1) {
        //MULTI PCB todo
        /* designs.push({
          id: "multi_pcb",
          name: "Multi-PCB"
        }) */
      }
      this.setState({
        designs,
        loading: true,
        logSweepMin: _logSweepMin,
        pathObj: {}
      }, () => {
        this.getCapacitance(true)
      })
    } catch (error) {
      console.error(error)
      this.setState({
        loading: false,
        isUpdateData: true,
        designs: [],
        pathObj: {},
        hideFreq: false
      })
    }
  }

  getCapacitance = async (isInit) => {
    const { verificationId, signalNameObj } = this.props;
    const { designs } = this.state;

    let _designs = [...designs || []], frequency = null, freqUnit = "", colorIndex = 0, pathObj = {}, displayMode = "curve";
    let index = 0, hideFreq = true;
    for (let item of _designs) {
      try {
        const capacitorJson = await getTotalTraceCapacitance(verificationId, item.id);
        const { tableData, hasSegment, curveContent, colorIndex: newColorIndex, } = getTotalTraceCapacitanceTableData({
          content: capacitorJson,
          pcbId: item.id,
          colorIndex,
          components: item.components,
          pathObj,
          verificationId,
          signalNameObj
        });
        colorIndex = newColorIndex;
        item.tableData = tableData || [];

        if (!item.isTemplateSchematic) {
          const freq = capacitorJson.frequency || "";
          const unit = freq.match(/K|M|G/ig);
          frequency = freq.replace(/K|M|G/ig, "");
          freqUnit = unit && unit[0] ? unit[0] : "";
          hideFreq = false;
        }
        item.capacitorJson = capacitorJson || {};
        item.curveContent = curveContent;
        item.hasSegment = hasSegment;
        item.isMulti = item.id === "multi_pcb";
        if (index === 0 && item.isTemplateSchematic && isInit) {
          displayMode = "table"
        }
        index++;
      } catch (error) {
        console.error(error)
        index++;
        continue;
      }
    }
    const { verificationId: _verificationId } = this.props;
    //loading slow -> result cover
    if (verificationId !== _verificationId) {
      return;
    }

    this.setState({
      designs,
      frequency,
      freqUnit,
      loading: false,
      pathObj,
      isUpdateData: true,
      displayMode: isInit ? displayMode : this.state.displayMode,
      hideFreq
    })
  }

  updateFrequency = async (value, isUnit) => {
    if (isUnit) {
      this.setState({
        frequency: value
      })
      return;
    }
    this.setState({
      frequency: value,
      loading: true
    }, async () => {
      await this.reCalcCapacitance();
    })
  }

  reCalcCapacitance = async () => {
    const { freqUnit, frequency } = this.state;
    const { verificationId } = this.props;
    try {
      await reCalcCapacitanceByFreq({ frequency: `${frequency}${freqUnit}`, verificationId });
      this.getCapacitance()
    } catch (error) {
      this.setState({
        loading: false
      })
    }
  }

  changeFreqUnit = (unit) => {
    this.setState({
      freqUnit: unit,
      /*    loading: true */
    }/* , async () => {
      await this.reCalcCapacitance();
    } */)
  }

  updateStatus = (isUpdateData) => {
    this.setState({
      isUpdateData
    })
  }

  updateDesignData = (designs) => {
    this.setState({
      designs
    })
  }

  setResultOpera = (newSetting) => {
    const { verificationId } = this.props;
    const { resultOpera } = this.state;
    this.setState({
      resultOpera: { ...resultOpera, ...newSetting }
    }, () => {
      resultOperation.setOperationByKey(verificationId, CAPACITANCE, { ...resultOpera, ...newSetting })
    })
  }

  render() {
    const { designs, frequency, freqUnit, loading, pathObj, isUpdateData, logSweepMin, resultOpera, displayMode, hideFreq } = this.state;
    const { verificationId } = this.props;

    return <div className='sierra-trace-capacitance-content'>
      <TotalCapacitance
        designs={designs}
        frequency={frequency}
        freqUnit={freqUnit}
        loading={loading}
        verificationId={verificationId}
        pathObj={pathObj}
        isUpdateData={isUpdateData}
        logSweepMin={logSweepMin}
        capacitancePlot={this.capacitancePlot}
        resultOpera={resultOpera}
        displayMode={displayMode}
        hideFreq={hideFreq}
        updateFrequency={this.updateFrequency}
        changeFreqUnit={this.changeFreqUnit}
        updateStatus={this.updateStatus}
        updateDesignData={this.updateDesignData}
        setResultOpera={this.setResultOpera}
      />
    </div>
  }
}

const mapState = (state) => {
  const { project, resultReducer: { resultInfo } } = state.SierraReducer;
  const { currentProjectId } = project;
  const { verificationSubId, verificationId } = resultInfo;
  return {
    verificationId,
    currentProjectId,
    verificationSubId
  }
}

export default connect(mapState, null)(TotalTraceCapacitance);